export default __webpack_public_path__ + "static/media/undo.2846c849.png";